import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Divider from '@zenbusiness/zui/Divider';
import Grid from '@zenbusiness/zui/Grid';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Text from '@zenbusiness/zui/Text';
import Tooltip from '@zenbusiness/zui/Tooltip';

import * as Styled from '../OrderView.style';

const LOCALIZED_TEXT = {
  heading: 'orderView.billingInfo.heading',
  name: 'orderView.billingInfo.name',
  email: 'orderView.billingInfo.email',
  card: 'orderView.billingInfo.card',
};

const BillingInfo = ({ loading, firstName, lastName, accountEmail, cardUsed }) => (
  <Styled.BillingInfoRoot>
    <Grid>
      <Grid item>
        <Text variant="body1" fontWeight="bold">
          <FormattedMessage id={LOCALIZED_TEXT.heading} />
        </Text>
      </Grid>
      <Grid item>
        <Divider />
      </Grid>
      {loading ? (
        <Grid item>
          <Skeleton variant="rectangular" height={100} />
        </Grid>
      ) : (
        <>
          <Styled.DetailsRow>
            <Text variant="body1" fontWeight="bold">
              <FormattedMessage id={LOCALIZED_TEXT.name} />
            </Text>
            <Text>
              {firstName} {lastName}
            </Text>
          </Styled.DetailsRow>
          <Styled.DetailsRow>
            <Text variant="body1" fontWeight="bold">
              <FormattedMessage id={LOCALIZED_TEXT.email} />
            </Text>
            <Tooltip arrow title={accountEmail}>
              <Styled.OverflowText>{accountEmail}</Styled.OverflowText>
            </Tooltip>
          </Styled.DetailsRow>
          <Styled.DetailsRow>
            <Text variant="body1" fontWeight="bold">
              <FormattedMessage id={LOCALIZED_TEXT.card} />
            </Text>
            <Text>{cardUsed}</Text>
          </Styled.DetailsRow>
        </>
      )}
    </Grid>
  </Styled.BillingInfoRoot>
);

BillingInfo.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  cardUsed: PropTypes.string.isRequired,
  accountEmail: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

export default BillingInfo;
